import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { RequiredInterfaces } from '../interfaces';
import { ReloadInterface } from '../interfaces/ReloadInterface';
import {
    Feature,
    getUrlQueryFeatures,
    hasUrlQueryFeature,
    isUrlQueryPlatform,
} from '../PlatformCheck';
import { PlayerPmc } from '../PlayerPmc';
import { type AndroidFlavor, androidFlavorImplementations, AndroidFlavors } from './AndroidFlavors';

export class AndroidPmcPlayer extends PlayerPmc implements RequiredInterfaces, ReloadInterface {
    readonly flavor: AndroidFlavor =
        androidFlavorImplementations[
            (getUrlQueryFeatures().find(
                (feature) => Object.values(AndroidFlavors).includes(feature as AndroidFlavors)
                /**
                 * typecasting is fine here because we use the values of `AndroidFlavors`
                 * to find the flavor and use the Unknown type if it doesn't exist.
                 */
            ) ?? AndroidFlavors.Unknown) as AndroidFlavors
        ];
    readonly name = `Android PMC Player ${this.flavor.name} Flavor`;

    static isTheRunningPlatform(): boolean {
        const thisPlatformIsRunning = isUrlQueryPlatform('Android');
        const thisPlatformSupportsPmc = hasUrlQueryFeature(Feature.PostMessageClient);
        return thisPlatformIsRunning === true && thisPlatformSupportsPmc;
    }

    async _generateAndGetHardwareId(): Promise<string> {
        const { uniqueIdentifier } = await this.postMessage(
            PlatformMessage.DeviceInformationGet,
            undefined
        );
        return `${this.flavor.hardwareIdPrefix}://${uniqueIdentifier}`;
    }
}
